// Hangul syllables, jamo, and compatibility jamo Unicode ranges.
const HANGUL_RE = /[가-힯ᄀ-ᇿ㄰-㆏]/;

export function containsHangul(s: string): boolean {
  return HANGUL_RE.test(s);
}
